import React, { Fragment } from 'react';
import {  LoaderBox} from '../components/utilities';



export default class MonetaWebFailed extends React.Component {
    constructor(props) {
        super(props);

        
        
    }

    //#region Events

    componentDidMount() {

       

    }
    
    render() {

        return (<div>Transazione fallita</div>)

        
    }
}

